"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_FAILURE = exports.CUSTOM_SUCCESS = exports.CUSTOM_REQUEST = exports.SAVE_FAILURE = exports.SAVE_SUCCESS = exports.SAVE_REQUEST = exports.FETCHONE_FAILURE = exports.FETCHONE_SUCCESS = exports.FETCHONE_REQUEST = exports.FETCH_FAILURE = exports.FETCH_SUCCESS = exports.FETCH_REQUEST = void 0;
exports.FETCH_REQUEST = 'entities/FETCH/REQUEST';
exports.FETCH_SUCCESS = 'entities/FETCH/SUCCESS';
exports.FETCH_FAILURE = 'entities/FETCH/FAILURE';
exports.FETCHONE_REQUEST = 'entities/FETCHONE/REQUEST';
exports.FETCHONE_SUCCESS = 'entities/FETCHONE/SUCCESS';
exports.FETCHONE_FAILURE = 'entities/FETCHONE/FAILURE';
exports.SAVE_REQUEST = 'entities/SAVE/REQUEST';
exports.SAVE_SUCCESS = 'entities/SAVE/SUCCESS';
exports.SAVE_FAILURE = 'entities/SAVE/FAILURE';
exports.CUSTOM_REQUEST = 'entities/CUSTOM/REQUEST';
exports.CUSTOM_SUCCESS = 'entities/CUSTOM/SUCCESS';
exports.CUSTOM_FAILURE = 'entities/CUSTOM/FAILURE';
//# sourceMappingURL=types.js.map